
import { mapActions } from 'vuex';

import { EXPERIMENT_NAMES } from '@/modules/experiment/domain/experiment.constants';
import { LANDING_PAGE_IDS, QUIZ_VARIANTS } from '@/modules/tour/domain/tour';
import { REGION_LOCALE_PILATES_28_DAY_CHALLENGE } from '@/services/constants';

export default {
  components: {
    LandingPagesLoseWeight: () => import('@/components/landing-pages/lose-weight/lose-weight'),
  },
  head() {
    return {
      title: this.$t('landingPage.meta.title'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('landingPage.meta.description'),
        },
        {
          name: 'robots',
          content: 'noindex',
        },
      ],
    };
  },
  computed: {
    regionAndLanguageEnabled() {
      return this.isAllowedRegionLocal(this.$countryCode, this.getLanguage);
    },
    landingVariant() {
      const experiments = this.$exp?.activeExperiments || [];
      const targetExperimentNames = [
        EXPERIMENT_NAMES.PILATES_28_DAY_CHALLENGE_BMI_STEP_V2_1906,
        EXPERIMENT_NAMES.PILATES_28_DAY_CHALLENGE_LP_NEW_IMAGE,
      ];

      const variant = experiments.find((exp) => targetExperimentNames.includes(exp.experiment.name));

      return variant ? String(variant.variants[0].tour) : String(QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_NEW_CHECKOUT);
    },
    shouldShowLanding() {
      return (
        this.regionAndLanguageEnabled &&
        [
          QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_NEW_CHECKOUT,
          QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_BMI_STEP_V1,
          QUIZ_VARIANTS.PILATES_28_DAY_CHALLENGE_BMI_STEP_V2,
        ].includes(this.getQuizVariant)
      );
    },
  },
  created() {
    this.setQuizVariantAction(this.landingVariant);
    this.setLandingPageIdAction(LANDING_PAGE_IDS.PILATES_28_DAY_CHALLENGE_NEW_CHECKOUT);
  },
  mounted() {
    if (!this.regionAndLanguageEnabled) {
      window.location.href = this.$getUrl('home');
    } else {
      this.landingPageGtmHandler();
    }
  },
  methods: {
    ...mapActions('quiz', ['setQuizVariantAction', 'setLandingPageIdAction']),
    isAllowedRegionLocal(countryCode, language) {
      return REGION_LOCALE_PILATES_28_DAY_CHALLENGE[countryCode]?.includes(language) ?? false;
    },
  },
};
